<div class="console-page">
  <div class="console-content">
    <app-page-header title="VTEX" description="Formulario de pago VTEX (legacy)."></app-page-header>
    <form [formGroup]="myForm" class="console-form-grid">
      <div class="console-field">
        <label class="console-field__label" for="currency">Moneda</label>
        <input class="console-input" id="currency" formControlName="currency" />
      </div>
      <div class="console-field">
        <label class="console-field__label" for="amount">Monto</label>
        <input class="console-input" id="amount" formControlName="amount" />
      </div>
      <div class="console-form-grid__full">
        <button type="button" class="console-btn console-btn--primary" (click)="generatePayment()">Pagar</button>
      </div>
    </form>
  </div>
</div>
